// Mock data for JAW Hire landing page clone (frontend-only)
const CDN = 'https://cdn.prod.website-files.com';
import serviceExtension from './assets/service-extension.webp';
import serviceConversion from './assets/service-conversion.webp';
import serviceNewbuild from './assets/service-newbuild.webp';

export const brand = {
  logo: `${CDN}/648787488a26ad266625279b/64a03e287f61c6fc9193b670_jaw-logo_white.svg`,
  email: 'info@coreestimating.co.uk',
  phone: '01752 922639',
  phoneHref: 'tel:01752922639',
  instagramIcon: `${CDN}/648787488a26ad266625279b/64a130a865d155b164c1f819_ico-instagram.svg`,
  arrow: `${CDN}/648787488a26ad266625279b/64a6c2082bcbd2c194bd4fbc_ico-arrow_right.svg`,
};

export const heroImage = `${CDN}/648787488a26ad266625279b/64b8ef86a313a283063401cb_JAW-58.webp`;

export const nav = [
  { label: 'Services', href: '#hire' },
  { label: 'Reviews', href: '/reviews' },
  { label: 'Our reports', href: '/reports' },
];

export const services = [
  {
    title: ['Extensions'],
    desc: 'Detailed estimates for single & double-storey extensions',
    price: 'FROM £295+VAT',
    img: serviceExtension,
    href: '/contact',
  },
  {
    title: ['Conversions'],
    desc: 'Accurate pricing for loft, garage & barn conversions',
    price: 'FROM £295+VAT',
    img: serviceConversion,
    href: '/contact',
  },
  {
    title: ['New builds'],
    desc: 'Full takeoffs and cost plans for new-build projects',
    price: 'FROM £325+VAT',
    img: serviceNewbuild,
    href: '/contact',
  },
  {
    title: ['Refurbs'],
    desc: 'Reliable estimates for renovations & refurbishments',
    price: 'FROM £195+VAT',
    img: 'https://images.unsplash.com/photo-1517581177682-a085bb7ffb15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxob21lJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3ODc1Nzc3Njd8MA&ixlib=rb-4.1.0&q=85',
    href: '/contact',
  },
];

export const vacuum = {
  title: ['Discover the', 'versatility of', 'outsourced estimating'],
  p1: "Unlock hours back in your week with professional construction estimating, delivered without the cost or overhead of a full-time in-house quantity surveyor. Our experienced estimators handle your take-offs, bills of quantities and priced proposals for you \u2014 from single-storey extensions to full new-builds \u2014 so you spend less time buried in spreadsheets and more time running your sites.",
  p2: "If you're tendering anywhere in the UK and don't have the capacity to price every job properly, outsourced estimating is a fast, fixed-fee way to protect your margin without slowing down your pipeline. Most estimates are turned around in days, not weeks.",
  image: `${CDN}/648787488a26ad266625279b/64b8ef87be49fd513e0c4e58_JAW-61.webp`,
  video: 'https://www.youtube.com/embed/BQT3-Jc6M2s',
};

export const stats = [
  'Fixed-fee pricing',
  'Turnaround in days',
  '20+ years experience',
  'UK-wide coverage',
];

export const roadSweeper = {
  title: ['Road sweeper hire', 'now available'],
  desc: 'Keep your site clean, safe, and on schedule with our brand-new operated road sweepers. Onboard pressure washers and gully suckers, experienced drivers, and emergency call-out across the South West.',
  image: `${CDN}/648787488a26ad266625279b/6a06a6de5c251a62b0e9ff41_JAW-22.webp`,
};

export const features = [
  {
    kicker: 'Versatility',
    heading: 'JAW boasts an extensive inventory of top-quality equipment for commercial projects.',
    body: 'From plant hire to vacuum excavation machinery, we offer a wide range of options to meet diverse project needs. Our comprehensive selection ensures that you have access to the right tools and machinery required to execute your commercial project efficiently.',
    cta: 'See equipment for hire',
    image: `${CDN}/648787488a26ad266625279b/6a0c67fd06ff4500a865628e_JAW%20Drone%205.webp`,
  },
  {
    kicker: 'Expertise',
    heading: 'Our experienced team provides expert guidance and support throughout the project lifecycle.',
    body: "We understand the unique challenges and requirements of commercial projects and offer valuable insights to help you make informed decisions. Whether it's equipment selection, project planning, or on-site assistance, we are dedicated to ensuring your project's success.",
    cta: 'Visit the FAQs',
    image: `${CDN}/648787488a26ad266625279b/64b8ef878fe952e6c8801932_JAW-62.webp`,
  },
  {
    kicker: 'Reliability',
    heading: 'At JAW, we prioritise reliability and safety.',
    body: 'All our equipment is well-maintained and undergoes regular inspections to ensure optimal performance. By choosing JAW, you can have confidence in the reliability of our equipment, reducing the risk of delays or unexpected breakdowns during your commercial project.',
    cta: 'Contact the team',
    image: `${CDN}/648787488a26ad266625279b/64b8ef807ff0029bc21956b6_JAW-20.webp`,
  },
];

const CDN2 = 'https://cdn.prod.website-files.com/64a02c3a3a0a0152e8dd2458';
export const machinery = [
  { name: 'Mini-excavators', img: `${CDN2}/64b9269961963f9c134d999a_JAW-28.jpg` },
  { name: 'Site dumpers', img: `${CDN2}/6a0c689530438fdd6504483a_IMG_0752.webp` },
  { name: 'Telescopic handlers', img: `${CDN2}/64b9257824a0d8fc83735b5b_JAW-30.jpg` },
  { name: 'Vacuum excavators', img: `${CDN2}/64b92348fc498c55d64d58bb_JAW-08.jpg` },
  { name: 'Excavators', img: `${CDN2}/64b92405c90c32a5f64cb6c8_JAW.jpg` },
  { name: 'Rollers', img: `${CDN2}/64b925d0ee991bc33561fd31_JAW-46.jpg` },
  { name: 'Midi-excavators', img: `${CDN2}/64b9261e5b7e1cc3d5756c3e_JAW-12-2.jpg` },
  { name: 'Road sweepers', img: `${CDN2}/6a06a8c95fcd058e2ab5010d_JAW-18.webp` },
];

export const reviews = [
  { name: 'Brett C', company: '', rating: 5, text: 'We had Sam price a fairly big extension for us and the communication was second to none, was no issue making amendments and was fairly priced to with a quick turn around. Will certainly be using again.' },
  { name: 'Matt S', company: 'Matthew Selleck MCIAT, Director @ Archico', rating: 5, text: 'Sam at Core is professional and reliable and I would trust for all estimating requirements.' },
  { name: 'Jay C', company: '', rating: 5, text: 'Great experience with core had a couple projects estimated which resulted in our favour. Highly recommended will continue to use for any project estimating big or small. Five stars.' },
  { name: 'Sam H', company: '', rating: 5, text: 'Super reliable team and super accurate feasibility estimates. The team are easy to deal with and answer any questions asked (even stupid ones). Would highly recommend if you want to know what your extension will cost before finalising expensive architectural designs.' },
  { name: 'James K', company: '', rating: 5, text: 'Very professional service, prompt and pleasant. Know what they are talking about and are very cooperative. They do countless jobs for me a month and can work with me at every scale, great company, highly recommend!' },
  { name: 'Verity C', company: '', rating: 5, text: 'After using cores services I cannot recommend them enough. They were very professional and efficient. Their team communicated clearly, provided detailed estimates, and delivered everything right on time. I felt confident in their expertise and would highly recommend their services.' },
  { name: 'Mason S', company: '', rating: 5, text: 'Sam did an electrical takeoff for me for a large luxury development. Super fast turn around and got it spot on, I would recommend. Worth the investment.' },
  { name: 'Brandon S', company: '', rating: 5, text: 'After using cores services I cannot recommend them enough. They were very professional and efficient. Their team communicated clearly, provided detailed estimates, and delivered everything right on time. I felt confident in their expertise and would highly recommend their services.' },
  { name: 'Connor L', company: '', rating: 5, text: 'Excellent service - extremely helpful throughout the whole process and accommodated all our needs as we required. Highly recommend & we will not be looking elsewhere for someone on this service.' },
  { name: 'Luke C', company: 'BASE Construction', rating: 5, text: 'CORE nailed the numbers, chased the trades, and turned it around fast. No edits needed. Just sent it straight to the client.' },
  { name: 'Tim M', company: '', rating: 5, text: 'Brilliant service! Asked Sam and the team to price quite a complex job for us and it was back within a week. Covered every little detail, no stone left unturned. Thank you Core estimating!' },
];

export const oneTeam = {
  title: ['one team', 'One goal'],
  p1: "Based in Plymouth, Core Estimating works with builders and developers right across the UK. Whether you're in the South West or scaling across multiple regions, our fully remote process means accurate estimating is only a set of drawings away.",
  p2: "When you choose Core, you're not just outsourcing your take-offs \u2013 you're gaining a dedicated estimating partner who genuinely cares about helping your business win more work and protect its margins.",
};

export const instagram = [
  {
    img: `${CDN2}/6a73183475d599003dfeb266_764373416_18096161348629501_1780595992501040168_n.jpeg`,
    caption: 'Another quality machine heading out the yard! A huge thank you to Phil Green for his continued custom and support. We\u2019re delighted to supply a brand-new Hitachi ZX33.',
    href: 'https://www.instagram.com/p/Dbp8Et9oIth/',
  },
  {
    img: `${CDN2}/6a71aac44e905c6676082359_756745514_18095996726629501_5567460853758336517_n.jpeg`,
    caption: 'Job Opportunity \u2013 Yard Operative / Machine Prep. We\u2019re looking for someone to join the team at JAW Hire, based at Doublebois, Liskeard.',
    href: 'https://www.instagram.com/p/DbnMS2BFQB0/',
  },
  {
    img: `${CDN2}/6a5a0bad73eb61e2c720ad90_747753328_18093151595629501_1520094453854381893_n.jpeg`,
    caption: 'Fresh Paint Friday! Say hello to our brand new Kubota KX060 Hi-Spec, now ready to join the fleet across the South West.',
    href: 'https://www.instagram.com/p/Da4-jldleaq/',
  },
  {
    img: `${CDN2}/6a5784f4386f5e131e76c5af_746909240_18092862062629501_8904967717113152986_n.jpeg`,
    caption: 'Today we had the pleasure of being on site with the one and only Digger Man Blog\u2019s Nick Drew! Keep an eye out for the content coming soon.',
    href: 'https://www.instagram.com/p/Da0ErASliyP/',
  },
];


export const faqCategories = [
  {
    category: 'Scope & Pricing',
    items: [
      {
        q: 'How much does a construction estimating service cost?',
        a: "Our pricing is based on the size and complexity of the project. Get in touch with your project details and we'll provide a fixed fee with no hidden costs.",
      },
      {
        q: 'What construction projects and trades do you estimate for?',
        a: "We cover new builds, refurbishments, extensions, conversions, and everything in between. If it's a domestic project, we can price it.",
      },
      {
        q: 'Can you handle multiple takeoffs and estimates at once?',
        a: 'Absolutely. We have a team of talented estimators and work with contractors on an ongoing basis, handling multiple estimates simultaneously. The more we understand your business, the faster and sharper we get.',
      },
    ],
  },
  {
    category: 'Turnaround & Delivery',
    items: [
      {
        q: 'How long does a construction takeoff and estimate take?',
        a: "Most estimates are turned around within 3\u20135 working days. Larger or more complex projects may take longer - we'll always give you a clear timeframe upfront.",
      },
      {
        q: 'How quickly can you turn around a tender estimate?',
        a: "Yes. If you have a tight deadline, flag it when you get in touch and we'll do everything we can to accommodate it.",
      },
      {
        q: 'What format do your estimates come in?',
        a: "We deliver a detailed, clearly itemised estimate in Excel. It's a tried and tested format that's designed to win work.",
      },
    ],
  },
  {
    category: 'Getting Started',
    items: [
      {
        q: 'How do I get a construction estimate from CORE?',
        a: "Get in touch by call, email, or text - whichever is easiest for you. We understand you're busy, so we keep it simple. Tell us about your project, what you need, and we'll take it from there.",
      },
      {
        q: 'What information do you need to produce an estimate?',
        a: "Ideally drawings, a specification, and any relevant site information. If you don't have everything, send us what you have - we'll tell you if we need anything else.",
      },
      {
        q: 'What size of builder or contractor do you work with?',
        a: "Our sweet spot is domestic contractors turning over between \u00a3500k and \u00a33m, but we work with businesses both smaller and larger than that. Where we add the most value is when you're behind on tenders, don't have a QS in-house, or don't yet have the experience to price work with confidence. If that sounds familiar, we can help.",
      },
    ],
  },
  {
    category: 'Working With Us',
    items: [
      {
        q: 'Do you work directly with my client or just with me?',
        a: "We work for you - all communication goes through you and your client relationship stays yours. That said, if it's ever helpful for us to liaise directly with your client, we can do that too.",
      },
      {
        q: 'What happens if the scope changes after the estimate is issued?',
        a: "We can revise and update estimates as the scope evolves. Depending on the scale of the change, this may be included or priced as a separate instruction - we'll always be transparent about that upfront.",
      },
      {
        q: 'What if another contractor sends the same tender?',
        a: "It happens. We treat every estimate as exclusive to the client who instructed it - we won't produce an estimate for the same tender for two competing contractors. Your pricing stays yours.",
      },
    ],
  },
  {
    category: 'Other',
    items: [
      {
        q: "What's the difference between an estimator and a Quantity Surveyor (QS)?",
        a: 'An estimator focuses on pricing work - pulling together labour, material, and subcontractor costs to produce a tender or budget figure before a project starts. A QS covers a broader scope: contract administration, valuations, variations, final accounts, and cost management through the life of a project.',
      },
      {
        q: 'What is a construction takeoff?',
        a: 'A takeoff (or material/quantity takeoff) is the process of measuring and listing every item of work from a set of drawings \u2014 timber lengths, plasterboard area, door sets, drainage runs, etc. It\u2019s called a "takeoff" because quantities are literally taken off the drawings, then priced against current rates to produce the estimate. Get the takeoff wrong and the estimate is wrong.',
      },
      {
        q: 'What areas of the UK do you cover?',
        a: "We work with contractors UK-wide from our Plymouth base. Whether you're in the South West or scaling across multiple regions, our process is fully remote. Drawings in, numbers back, no geography involved.",
      },
    ],
  },
];
